import React, { useState, Fragment, useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { useAuth } from "../../context/AuthContext";
import { Dialog, Transition } from "@headlessui/react";
import { useHistory } from "react-router-dom";
import { db } from "../../firebase";
// import reviewBg from "../../assets/images/reviewBg.png";
import bgProfile from "../../assets/images/frame.png";
import { getClickableLink } from "../../utils";
import { ToastContainer, toast } from "react-toastify";

function MentorProfile({ match }) {
  const { currentUser } = useAuth();
  let [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [topics, setTopics] = useState();
  const [mentorProfile, setmentorProfile] = useState({});
  const [interests, setInterests] = useState();
  const history = useHistory();

  const getUserData = (userid) => {
    return new Promise((resolve, reject) => {
      db.collection("mentors")
        .where("username", "==", userid)
        .get()
        .then((querySnapshot) => {
          try {
            querySnapshot.forEach((doc) => {
              resolve(doc.data());
            });
          } catch (e) {
            reject({});
          }
        })
        .catch((error) => {
          reject(error);
          console.log("Error getting documents: ", error);
        });
    });
  };
  useEffect(() => {
    if (sessionStorage.getItem("mentorData") == null) {
      getUserData(match.params.username)
        .then((responseJson) => {
          setmentorProfile(responseJson);
        })
        .catch((err) => {
          history.push("/404");
        });
    } else {
      for (
        var i = 0;
        i < JSON.parse(sessionStorage.getItem("mentorData")).length;
        i++
      ) {
        if (
          JSON.parse(sessionStorage.getItem("mentorData"))[i].username ===
          match.params.username
        ) {
          let data = JSON.parse(sessionStorage.getItem("mentorData"))[i];
          setmentorProfile(data);
          setInterests(data.interest.join(", "));
          setTopics(data.topics.join(", "));
        }
      }
    }
  }, [match.params.username, history]);

  const handleDropDown = () => {
    open ? setOpen(false) : setOpen(true);
  };

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function login() {
    history.push("/login");
  }

  return (
    <div className={isOpen ? "opacity-20" : "bg-opacity-0"}>
      <Header />
      <div className="bg-white">
        <div>
          <div
            className={
              isOpen
                ? "opacity-20 h-48 w-full bg-cover "
                : "h-48 w-full bg-cover bg-blue-100"
            }
            style={{
              backgroundImage: `url(${bgProfile})`,
            }}
          ></div>
          <div className="container  mx-auto px-4 sm:px-2">
            <div className=" flex justify-between lg:flex-row flex-col">
              <div className="flex lg:flex-row flex-col">
                <div
                  className="w-36 h-36 bg-cover bg-blue-200 rounded-full bg-center absolute transform -translate-y-1/2 ring-4 ring-white"
                  style={{
                    backgroundImage: `url(${mentorProfile.profilePic})`,
                    backgroundSize: "cover",
                  }}
                ></div>
                <div className="sm: px-0">
                  <p className="lg:ml-36 mt-16 lg:mt-0 sm:pl-4 text-3xl font-semibold py-5">
                    {mentorProfile.name}
                  </p>
                  <p className="lg:ml-36 sm:pl-4 -mt-4 text-sm font-semibold text-gray-500">
                    {mentorProfile.role !== "NA" ? (
                      <>
                        <span className="font-semibold text-gray-900">
                          {mentorProfile.role}
                        </span>{" "}
                        at{" "}
                      </>
                    ) : (
                      ""
                    )}
                    <span className="font-semibold text-gray-900">
                      {mentorProfile.company !== "NA"
                        ? mentorProfile.company
                        : ""}
                      <div className="flex items-center justify-start">
                        {mentorProfile.linkedin ? (
                          <a
                            className="pt-2"
                            href={getClickableLink(`${mentorProfile.linkedin}`)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <svg
                              viewBox="0 0 24 24"
                              className="w-4 h-4 fill-current"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
                              <path d="m.396 7.977h4.976v16.023h-4.976z" />
                              <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
                            </svg>
                          </a>
                        ) : (
                          ""
                        )}
                        {mentorProfile.github ? (
                          <a
                            className="pt-2"
                            href={getClickableLink(`${mentorProfile.github}`)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              className="w-4 h-4 fill-current ml-4"
                            >
                              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                            </svg>
                          </a>
                        ) : (
                          ""
                        )}{" "}
                      </div>
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap py-5 space-x-3">
                <div class="relative h-full text-left items-center justify-center">
                  <div>
                    <button
                      type="button"
                      onClick={handleDropDown}
                      class="inline-flex  h-full justify-center w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none "
                      id="menu-button"
                      aria-expanded="true"
                      aria-haspopup="true"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 fill-current"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                        />
                      </svg>
                    </button>
                  </div>

                  {open && (
                    <div
                      class="z-10 origin-top-left absolute sm:right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1"
                    >
                      <div class="py-2" role="none">
                        <a
                          href={`https://twitter.com/intent/tweet?text=Hey!%20meet%20${mentorProfile.name}%20on%20Dev%20Colony&url=${window.location.href}&hashtags=devcolony,community`}
                          class="text-blue-500 block px-4 py-2 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          target="_blank"
                          rel="noreferrer"
                          id="menu-item-6"
                        >
                          <svg
                            fill="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            className="w-5 h-5 inline-block mr-2"
                            viewBox="0 0 24 24"
                          >
                            <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                          </svg>
                          <span className="text-gray-900">
                            Tweet this profile
                          </span>
                        </a>
                      </div>
                      <div class="py-2" role="none">
                        <a
                          href={`http://www.facebook.com/sharer.php?u=${window.location.href}&quote=Hey!%20meet%20${mentorProfile.name}%20on%20Dev%20Colony`}
                          class="text-blue-600 block px-4 py-2 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          target="_blank"
                          rel="noreferrer"
                          id="menu-item-6"
                        >
                          <svg
                            fill="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            className="w-5 h-5 inline-block mr-2"
                            viewBox="0 0 24 24"
                          >
                            <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                          </svg>
                          <span className="text-gray-900">
                            Share on Facebook
                          </span>
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                {currentUser ? (
                  <div>
                    {mentorProfile.public ? (
                      <a
                        href={getClickableLink(`${mentorProfile.meetLink}`)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className="lg:w-auto inline-flex w-full bg-gradient-to-r from-blue-500 to-blue-900 font-semibold tracking-wide justify-center w-full items-center text-gray-50 space-x-1.5 focus:ring-1 focus:ring-gray-300 focus:ring-offset-2 hover:bg-gray-900 focus:outline-none px-4 py-3 text-sm rounded-lg">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4 fill-current"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18.48 22.926l-1.193.658c-6.979 3.621-19.082-17.494-12.279-21.484l1.145-.637 3.714 6.467-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zm-9.808-22.926l-1.68.975 3.714 6.466 1.681-.975-3.715-6.466zm8.613 14.997l-1.68.975 3.714 6.467 1.681-.975-3.715-6.467z" />
                            </svg>
                          </span>

                          <span>Book Session</span>
                        </button>
                      </a>
                    ) : (
                      <button className="lg:w-auto inline-flex w-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 font-semibold tracking-wide justify-center w-full items-center text-white space-x-1.5 focus:ring-1 focus:ring-gray-300 focus:ring-offset-2 hover:bg-gray-900 focus:outline-none px-4 py-3 text-sm rounded-lg">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                            />
                          </svg>
                        </span>

                        <span>On a Break</span>
                      </button>
                    )}
                  </div>
                ) : (
                  <div>
                    <button
                      onClick={openModal}
                      className="lg:w-auto inline-flex w-full bg-gradient-to-r from-blue-500 to-blue-900 font-semibold tracking-wide justify-center w-full items-center text-gray-50 space-x-1.5 border border-gray-400 focus:ring-1 focus:ring-gray-300 focus:ring-offset-2 hover:bg-gray-900 focus:outline-none px-4 py-3 text-sm rounded-lg"
                    >
                      <span>Book a Session</span>
                    </button>
                    <Transition appear show={isOpen} as={Fragment}>
                      <Dialog
                        as="div"
                        className="fixed inset-0 z-10 overflow-y-auto"
                        onClose={closeModal}
                      >
                        <div className="min-h-screen px-4 text-center">
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Dialog.Overlay className="fixed inset-0" />
                          </Transition.Child>

                          <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                          >
                            &#8203;
                          </span>
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                          >
                            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl rounded-2xl ">
                              <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                              >
                                You need to login to schedule with mentor
                              </Dialog.Title>

                              <div className="mt-8 text-right">
                                <button
                                  type="button"
                                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                  onClick={closeModal}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="ml-4 inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-blue-900 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                  onClick={login}
                                >
                                  Log in
                                </button>
                              </div>
                            </div>
                          </Transition.Child>
                        </div>
                      </Dialog>
                    </Transition>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container  mx-auto px-4 sm:px-2 mb-12">
        <div className="block md:flex">
          <div className="w-full md:w-2/5 mt-8 p-2 bg-white">
            <div className="flex justify-between">
              <span className="font-semibold mb-4">About Me</span>
            </div>

            {mentorProfile.bio ? (
              <span className="font-base text-gray-700">
                {mentorProfile.bio}
              </span>
            ) : (
              <span className="font-base text-gray-700">
                Information not provided by the mentor
              </span>
            )}
            <div className="flex items-top mt-6 text-gray-700">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h1 className="ml-2 text-base sm: text-sm">
                I'm mentoring{" "}
                <span className="font-semibold ">{interests}</span>
              </h1>
            </div>
            {/* <div className="flex items-top mt-6 text-gray-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                />
              </svg>
              <h1 className="ml-2 text-base sm: text-sm">
                I speak{" "}
                <span className="font-semibold">{mentorProfile.commLang}</span>
              </h1>
            </div> */}
            <div className="flex items-top mt-6 text-gray-700">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>
              <h1 className="ml-2 text-base sm: text-sm">
                Ask me about <span className="font-semibold">{topics}</span>
              </h1>
            </div>
          </div>

          <div className="w-full md:w-3/5 sm: p-2 bg-white py-8 lg:ml-4">
            <span className="font-semibold">Reviews</span>
            <div className="rounded ">
              <div
                className="h-36 m-auto bg-blue-50 mt-4 rounded-xl relative text-white"
                // style={{
                //   backgroundImage: `url(${bgProfile})`,
                //   backgroundSize: "auto",
                //   backgroundRepeat: "no-repeat",
                //   backgroundPositionX: "right",
                // }}
              >
                <div className="px-4 sm:px-8 hidden sm:flex">
                  <h2 className="font-base text-sm pt-6 text-gray-700">
                    Be detailed, specific and honest
                  </h2>
                </div>
                <div className="w-full px-4 sm:px-8 absolute top-24 sm:top-20">
                  {currentUser ? (
                    <button
                      onClick={() => toast.warn("We're in beta right now!")}
                      className="bg-gradient-to-r from-blue-500 to-blue-900 rounded-lg p-2 sm:p-2.5"
                    >
                      <p className="text-white font-medium text-sm sm:text-sm">
                        Write a review
                      </p>
                    </button>
                  ) : (
                    <button
                      onClick={openModal}
                      className="bg-gradient-to-r from-blue-500 to-blue-900 rounded-lg p-2 sm:p-2.5"
                    >
                      <p className="text-white font-medium text-sm sm:text-sm">
                        Write a review
                      </p>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer hideProgressBar={true} position="top-right" />
    </div>
  );
}

export default MentorProfile;
